<script>
export default {
  functional: true,
  render(h, context) {
    return context.props.node
  }
}
</script>
